// extracted by mini-css-extract-plugin
export default {"ver1CurrentCopy2":"Ver1CurrentCopy2_ver1CurrentCopy2__bVR+R"};